// Copyright (c) StrangeBee 2024

import { UserOutput } from 'thehive-sdk';

export const SystemUser: UserOutput = {
    login: 'system@thehive.local',
    hasKey: false,
    hasMFA: false,
    hasPassword: false,
    locked: false,
    name: 'TheHive system user',
    organisation: '',
    organisations: [],
    permissions: [],
    profile: '',
    _createdAt: 0,
    _createdBy: '',
    _id: '',
    type: 'Normal',
};
